export default function AboutArchivePage() {
  return (
    // Same width as the site grid so the two columns line up with the nav.
    // No pb — like the home page, the footer's pt sets the gap below the
    // content, so the bottom whitespace matches across pages
    <section className="max-w-[1287px] mx-auto px-6 pt-14">
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_470px] gap-x-14 gap-y-12 items-start">
        {/* About the archive */}
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-seal mb-[10.5px]">
            About the Archive
          </p>
          <h1 className="font-display text-4xl text-ink leading-tight mb-3.5">
            A country in miniature.
          </h1>
          <div className="space-y-3 font-serif text-base leading-relaxed text-ink/80">
            <p>
              The Japanese Stamp Archive is an independent project shaped by a
              passion for Japanese culture, 20th-century graphic design, and the
              history of print and correspondence. It was created to preserve
              small but meaningful objects of visual and cultural significance
              so that they can be studied and enjoyed by a wider audience. The
              archive focuses primarily on Japanese stamps and postal material
              from the postwar decades.
            </p>
            <p>
              The items presented come from a personal collection. Each stamp,
              first-day cover, and postal artefact has been selected for its
              design quality, historical significance, or cultural interest,
              then carefully digitized and catalogued. All items are scanned
              under consistent conditions. Post-processing is limited to minor
              digital cleaning where necessary, so that each artefact&rsquo;s
              original colour, texture, proportions, and imperfections are
              represented as faithfully as possible.
            </p>
            <p>
              The archive uses the <i>Sakura Catalogue of Japanese Stamps</i>,
              published by the Japan Philatelic Society Foundation, as its
              primary cataloguing reference. Although the <i>Scott Catalogue</i>{" "}
              provides a widely recognized international reference, the{" "}
              <i>Sakura Catalogue</i> was chosen for its level of detail, its
              grounding in Japanese philatelic expertise, and its affordability,
              making it readily accessible to those wishing to explore
              Japan&rsquo;s postal heritage beyond the scope of the archive.
              Information from the catalogue has been supplemented by original
              notes and articles drawing on research across a range of sources.
            </p>
            <p>
              Original writing, photography, graphics, and other content created
              for this website are protected by copyright &copy; 2026 The
              Japanese Stamp Archive. The stamps, first-day covers, and other
              postal artefacts displayed may be subject to separate rights held
              by their respective owners. No infringement of those rights is
              intended. The Japanese Stamp Archive is not affiliated with Japan
              Post or the Japan Philatelic Society Foundation.
            </p>
          </div>
        </div>

        {/* Meet the team — deliberately a size down from the main column.
            Pulled up by its own top padding on lg so its eyebrow sits level
            with the one in the main column */}
        <aside className="border border-ink/10 rounded-lg p-6 sm:p-7 lg:-mt-7">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-seal mb-[10.5px]">
            Meet the Team
          </p>

          <h2 className="font-display text-3xl text-ink leading-tight mb-3">
            Alex
          </h2>
          <div className="space-y-3 font-serif text-sm leading-relaxed text-ink/80">
            <p>
              I lead the archive&rsquo;s content and research. I collected
              stamps as a child and returned to the hobby decades later through
              a deep interest in Japanese culture. Developing the archive gives
              me a unique window into Japan&rsquo;s everyday life, traditions,
              and places &ndash; allowing me to travel there in spirit while
              inspiring ideas for future trips. It is also a fantastic way to
              spend the long Canadian winters: hunting down items, researching
              the stories behind them, and carefully preparing them for
              publication.
            </p>
            <p>
              I am Belgian Canadian, I live in Montr&eacute;al, and my
              professional background is in education and communications. I have
              visited Japan several times, for both work and pleasure.
            </p>
          </div>

          <h2 className="font-display text-3xl text-ink leading-tight mt-5 mb-3">
            William
          </h2>
          <div className="space-y-3 font-serif text-sm leading-relaxed text-ink/80">
            <p>
              I designed and built the site&rsquo;s architecture, navigation,
              and features. The archive&rsquo;s visual language draws on
              editorial design and museum catalogues, reflecting the physical
              character of the stamps and keeping them at the centre of the
              user&rsquo;s experience. Working on this project has given me the
              opportunity to learn more about Japanese culture and postal
              history. While I have yet to visit Japan, it is at the top of my
              travel list.
            </p>
            <p>
              I was born in Canada and am based in Montr&eacute;al. I am a{" "}
              <a
                href="https://www.linkedin.com/in/william-wl-hu"
                target="_blank"
                rel="noopener noreferrer"
                className="text-seal underline underline-offset-2 hover:text-seal-deep"
              >
                full-stack web developer
              </a>{" "}
              specializing in website design and am available for selected
              personal, small-business, and custom web projects.
            </p>
          </div>
        </aside>
      </div>
    </section>
  );
}
